
// Map of English category keys to French category names that will ensure consistency across all components
export const CATEGORY_TRANSLATIONS: Record<string, string> = {
  'starters': 'Entrées',
  'mains': 'Plats',
  'desserts': 'Desserts',
  'drinks': 'Boissons',
  'pizzas': 'Pizzas',
  'sides': 'Accompagnements',
  'vegan': 'Vegan',
  'beer': 'Bières',
  'wine': 'Vins',
  'cocktails': 'Cocktails',
  'spirits': 'Spiritueux',
  'alcohol_free': 'Sans alcool',
  'healthy': 'Healthy',
  'vegetarian': 'Végétarien',
  'gluten_free': 'Sans gluten',
  'pinard': 'Pinard'
};
